import React from 'react';
import Notifications from '../components/notifications/index';

function NotificationsPage() {
    return <Notifications />;
}

export default NotificationsPage;
